<template>
	<div style="width: 100vw;" >
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading  color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width: 100%;"></div> -->
		<div
			:style="equipment == 'pc'?{
					// width:equipment == 'pc'?'1280px':'100%'
					...boxStyleOne,
					minHeight:`calc(100vh - ${placeNavHeight}px)`
				}:{
					width:'96%',
					minHeight:`calc(100vh - ${placeNavHeight}px)`
				}"
			style="display: flex;background-color: #ffffff;margin: auto;flex-direction: column;">
			<div v-if="data" style="display: flex;align-items: center;flex-wrap: wrap;margin: 20px;">
				<div>
					{{$t('h.selectClassfiy')}}
				</div>
				<el-select  class="custom-select" @change="changePageCategories" :style="{
					marginLeft:equipment == 'pc'?'20px':'0px',
					marginTop:equipment == 'pc'?'0px':'20px'
				}"
					v-model="value" >
					<el-option v-for="item in data.active_page_categories.data" :key="item.id"
						:label="item.description.title" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div v-if="data" style="display: flex;align-items: center;flex-wrap: wrap;">
				<div  @click="navTo(item)" style="margin: 20px;display: flex;align-items: center;" v-for="(item,index) in data.category_pages.data"
					:key="index">
					<div class="tit">{{item.description.title}}</div>
					<!-- <div style="display: flex;margin-left: 10px;color: #cecece;font-size: 14px;">
						{{item.description.created_at}}
					</div> -->
				</div>
			</div>
		</div>
		<!-- <div style="height: 30px;width: 100%;"></div> -->
	</div>
</template>

<script>
	import {
		getPageCategories
	} from '../../../api/all.js'
	export default {
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				articles: [],
				loading: false,
				data: null,
				value: ""
			}
		},
		mounted() {
			this.value = parseInt(this.$route.params.id)
			this.getData()
		},
		watch: {
			$route: {
				deep: true,
				handler: async function(to, from) {
					this.value = parseInt(to.params.id)
					this.getData()
				}
			}
		},
		methods: {
			navTo(item) {
				this.$router.push({
					path: '/pages/' + item.id,
				})
			},
			changePageCategories(e) {
				console.log('e', e)
				this.getData()
			},
			getArticles() {},
			async getData() {
				try {
					this.loading = true
					const data = await getPageCategories({
						id: this.value
					})
					this.data = data.data.data
					if (this.data.active_page_categories.length > 0) {

					}
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			}
		}
	}
</script>

<style scoped>
	.custom-select /deep/ .el-input__inner {
	}

	/deep/ .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #635bff;
	}
	/deep/ .el-select .el-input__inner:focus{
		border: 1px solid #635bff;
	}
	.tit:hover {
		color: #635bff;
		cursor: pointer;
	}
</style>